import { EventEmitter, Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class CustomeHeaderService {
  isResetFilterIcon = new EventEmitter();
  columnCheckboxChecked = new EventEmitter();
  constructor() { }
}
